<!--  *ngIf="_appService.CoreCommonLiterals && _gearAppService.GearManagerLiterals"  -->
<generic-page
  *ngIf="_appService.CoreCommonLiterals"
  [title]="_appService.CoreCommonLiterals.GraphicalViewPlans + _facilityDescription"
  [errorMessage]="_errorBackEnd"
  [goBackOnCancel]="false"
  [isGeneric]="true">
  <table-cmp
    rememberFilters="true"
    [masterDataEntityContent]="_masterDataEntityContent"
    [enablePagination]="true"
    [showTotalRowCount]="true"
    [rowsPerPage]="10"
    editRoute="plan/edit/"
    addRoute="plan/add/"
    (onRemove)="confirmOnRemove($event)"
    (onCustom1)="cloneView($event)"
  ></table-cmp>
  <button id="table-btn-back" class="btn btn-primary mr-2" (click)="goBack('plan')"><i class="fa-solid fa-reply" style="font-weight: 900; font-family: 'Font Awesome 5 Free';"></i> {{_appService.CoreCommonLiterals.GoBack}}</button>
</generic-page>

<modal-confirm #confirmRemove [title]="_appService.CoreCommonLiterals.Delete + ' - ' + _appService.CoreCommonLiterals.GraphicalViewPlans"
  [content]="_appService.CoreCommonLiterals.SureYouWantToContinue"
  [submitButtonText]="_appService.CoreCommonLiterals.ButtonConfirm"
  (submit)="remove()"
  [(errorMessage)]="_errorMessage"
  [closeButtonText]="_appService.CoreCommonLiterals.ButtonCancel">
</modal-confirm>

<modal #modalCloneView
  id="edit-modal"
  modalClass="modal-lg"
  [(errorMessage)]="_errorMessage"
  [submitButtonText]="_appService.CoreCommonLiterals.ButtonSave"
  (onSubmit)="saveGraphicalView(formElement)"
  [closeButtonText]="_appService.CoreCommonLiterals.ButtonCancel"
  >
  <modal-header>{{_appService.CoreCommonLiterals.CloneViewPlans}}</modal-header>
  <modal-content>
    <form #formElement="ngForm" class="row">
      <div class="form-group col-12" *ngIf="_pageStatus !== 0">
        <label for="description" class="mt-3">{{_appService.CoreCommonLiterals.Description}}</label>
        <div class="input-group">
          <input
          type="text"
          id="description"
          class="form-control"
          name="description"
          (click)="_errorMessage = ''"
          [(ngModel)]="_description"
          #address="ngModel"
          required/>
        </div>
      </div>
    </form>
    <div class="text-center" *ngIf="_pageStatus === 0">
      <i class="fas fa-circle-notch fa-spin fa-2x"></i>
    </div>
  </modal-content>
</modal>
